import { useState, useCallback, useEffect } from "react";
import EventTargetLocal from "../shared/EventTarget";
import { isUnder } from "../utils";

export const event = new EventTargetLocal();

const useLocalStorage = (key: string): [any, (data?: any) => void] => {
    const [data, setData] = useState(() => {
        const result = localStorage.getItem(key);
        return result;
    })
    useEffect(() => {
        const listener = (e: CustomEvent) => {
            let data = e.detail
            if (isUnder(data)) {
                localStorage.removeItem(key)
            } else if (typeof data !== 'string') {
                data = JSON.stringify(data)
            }
            if (!isUnder(data)) {
                localStorage.setItem(key, data);
            }
            setData(data);
        }
        event.addEventListener(key, listener);
        return () => {
            event.removeEventListener(key, listener)
        }
    }, [key])
    const update = useCallback((data: any) => {
        event.dispatchEvent(new CustomEvent(key, {detail: data}))
    }, [key])
    return [data, update]
}

export default useLocalStorage;